import React, {FC, Fragment} from "react";
import cls from "./pagination.module.scss";
import {ArrowRoundedLeft8x13Svg, ArrowRoundedRight8x13Svg} from "../../../../svg";
import {useRouter} from "next/router";

interface IPaginationProps {
    total: number,
    getPages: Array<number>
}

const CustomPagination: FC<IPaginationProps> = ({total = 1, getPages}) => {
    const {query: {page: current = 1, ...query}, push: routerPush} = useRouter();
    const handleClick = async ({ setPageVal, condition }: { setPageVal: number, condition: boolean }) => {
        if (Number(setPageVal) !== Number(current) && condition) {
            window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
            await routerPush({query: {...query, page: String(setPageVal)}})
        }
    }

    const pageChangeArrow = (condition: boolean, ariaLabel: "Next" | "Previous", setPageVal: number, arrowSide: "left" | "right") => {
        const svgArrowProps: { [x: string]: string } = {
            className: `${cls["page-link__arrow"]} ${cls[`page-link__arrow--${arrowSide}`]}`,
            "aria-hidden": "true"
        }
        const svgSideElemHandle = {
            left: <ArrowRoundedLeft8x13Svg {...svgArrowProps} />,
            right: <ArrowRoundedRight8x13Svg {...svgArrowProps} />
        }
        return (
            <li className={`${cls["page-item"]} ${!condition ? cls["page-item-disabled"] : ""}`}>
                <button
                    className={`${cls["page-link"]} ${cls["page-link--with-arrow"]}`}
                    aria-label={ariaLabel}
                    onClick={() => handleClick({ setPageVal, condition })}
                >
                    {svgSideElemHandle[arrowSide]}
                </button>
            </li>
        )
    }

    return (
        <ul className={cls["pagination"]}>
            {pageChangeArrow(current > 1, "Previous", +current - 1, "left")}
            {getPages?.map((page, index) => (
                <li key={index} className={page === +current ? cls["page-item-active"] : ""}>
                    <button className={cls["page-link"]} onClick={() => handleClick({ setPageVal: page, condition: current !== page })}>
                        {page}
                        {page === +current ? (
                            <span className={cls["sr-only"]}>{current}</span>
                        ) : <Fragment />}
                    </button>
                </li>
            ))}
            {pageChangeArrow(current < total, "Next", +current + 1, "right")}
        </ul>
    );

}

export default CustomPagination;
